import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn} from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';

export default function P302List3({ dataTable, onRowClick }) {

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // header={header}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    onRowClick={onRowClick}
                    selectionMode="single"
                >
                    <Column field="supervisorSeq" header="ลำดับ" body={(e) => normalColumn(e, 'recSeq', 'ลำดับ')} style={{textAlign: 'center',width: '20%'}} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="recName" header="ชื่อ-นามสกุล" body={(e) => normalColumn(e, 'recName', 'ชื่อ-นามสกุล')} style={{ textAlign: 'center'}}  bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="recTitle" header="ตำแหน่ง" body={(e) => normalColumn(e, 'recTitle', 'ตำแหน่ง')} style={{ textAlign: 'center',width: '30%' }}   bodyStyle={bodyStyle.TXT_LEFT_OVER} />

                </DataTable>
            </div>
        </div>
    )
}
